import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable, Subject } from 'rxjs';
import { URL_SERVICIOS_SOCKET, ENVIRONMENT } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class SocketWebRtcService {

  private socket: Socket;

  // 🔹 NUEVO: Subject para estados WebRTC de usuario (paciente)
  private webrtcUserStatus$ = new Subject<any>();

  constructor() {
    this.socket = io(URL_SERVICIOS_SOCKET, {
        transports: ['websocket'],
        withCredentials: true
      });

    this.socket.on('connect', () => {
      // console.log(
      //   '✅ Conectado a socket webrtc',
      //   'url:', URL_SERVICIOS_SOCKET,
      //   'ambiente:', ENVIRONMENT
      // );
    });

    this.socket.on('connect_error', (err) => {
      console.error(
        '❌ Error de conexión socket webrtc:',
        err,
        'url:', URL_SERVICIOS_SOCKET,
        'ambiente:', ENVIRONMENT
      );
    });

    // 🔹 NUEVO: listener global para estados del paciente
    this.socket.on('webRTC:webrtcUserStatus', (payload: any) => {
      this.webrtcUserStatus$.next(payload);
    });
  }

  /* =========================
   * EMIT
   * ========================= */

  joinRoom(data: any) {
    this.socket.emit('webRTC:join', data);
  }

  socketEmit(topic: string, data: any, event?: any) {
    if (!event) {
      this.socket.emit('webRTC:' + topic, data);
      return;
    }
    this.socket.emit('webRTC:' + topic, event, data);
  }

  socketExit() {
    this.socket.disconnect();
  }

  /* =========================
   * OBSERVABLES CLÁSICOS
   * ========================= */

  joined(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('webRTC:joined', data => observer.next(data));
    });
  }

  created(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('webRTC:created', data => observer.next(data));
    });
  }

  offer(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('webRTC:offer', data => observer.next(data));
    });
  }

  answer(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('webRTC:answer', data => observer.next(data));
    });
  }

  candidate(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('webRTC:candidate', data => observer.next(data));
    });
  }

  ready(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('webRTC:ready', data => observer.next(data));
    });
  }

  full(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('webRTC:full', data => observer.next(data));
    });
  }

  participants(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('webRTC:participants', data => observer.next(data));
    });
  }

  leave(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('leave', data => observer.next(data));
    });
  }

  endMeetingByDoctor(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('webRTC:endMeetingByDoctor', data => observer.next(data));
    });
  }

  isNotCompatible(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('webRTC:isNotCompatible', data => observer.next(data));
    });
  }

  isNotAuthorized(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('webRTC:isNotAuthorized', data => observer.next(data));
    });
  }

  /* =========================
   /* 🆕 ESTADOS DEL PACIENTE
   /* ========================= */

  /**
   * Observable que emite estados del paciente:
   * PATIENT_JOIN_ROOM_SENT
   * PATIENT_MEDIA_OK
   * PATIENT_MEDIA_DENIED
   * PATIENT_WEBRTC_CONNECTED
   * PATIENT_LEFT
   * etc.
   */
  webrtcUserStatus(): Observable<any> {
    return this.webrtcUserStatus$.asObservable();
  }
}
